import React from "react";

export class AppErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Errore di rendering Cosmely", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <main role="alert" className="min-h-screen bg-[#FAF9F6] flex items-center justify-center px-6"
            data-testid="global-render-error">
        <div className="max-w-lg text-center">
          <h1 className="font-serif text-4xl text-[#1A1A1A]" data-testid="global-render-error-title">
            Si è verificato un problema
          </h1>
          <p className="mt-5 text-sm text-[#4A4A4A]" data-testid="global-render-error-description">
            Questa pagina non può essere visualizzata. Ricaricala per riprovare.
          </p>
          <button type="button" className="btn-primary mt-8" onClick={() => window.location.reload()}
                  data-testid="global-render-error-reload">Ricarica pagina</button>
        </div>
      </main>
    );
  }
}